/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-dni[_ngcontent-%COMP%]{width:90%}.dni-tip[_ngcontent-%COMP%]{padding-left:5%;display:flex;justify-content:center;align-items:center;color:#db38b7}"];
export { styles as styles };
